// extracted by mini-css-extract-plugin
export default {"wrapper":"w__vCy","price":"L4OUy5","price--bnpl":"acSjLB","price--installment":"evCqnE"};